import * as React from 'react';

function FilterTagCloseCross() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icon/control/close (cross)">
        <path
          id="close"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.39261 7.00006L3.37407 3.90829C3.23087 3.76162 3.23077 3.52371 3.37383 3.3769C3.51689 3.2301 3.74894 3.22998 3.89214 3.37665L6.97496 6.53426C6.99159 6.5331 7.00828 6.5331 7.02491 6.53426L10.1077 3.37665C10.2509 3.22998 10.483 3.2301 10.626 3.3769C10.7691 3.52371 10.769 3.76162 10.6258 3.90829L7.60726 7.00006L10.6258 10.0918C10.769 10.2385 10.7691 10.4764 10.626 10.6232C10.483 10.77 10.2509 10.7701 10.1077 10.6235L7.02491 7.46586C7.00828 7.46701 6.99159 7.46701 6.97496 7.46586L3.89214 10.6235C3.74894 10.7701 3.51689 10.77 3.37383 10.6232C3.23077 10.4764 3.23087 10.2385 3.37407 10.0918L6.39261 7.00006Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export default FilterTagCloseCross;
